import axios from "axios";
import axiosInstance from './index';

export const createPaymentLink = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `payment/generate-order`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};
